<script async setup lang="ts">
import { computed } from 'vue';
import { useEventStore } from '@/stores/events.store';
import { EventEntity } from '@/entities/interfaces/events';
import CourseBanner from '../custom/sections/CourseBanner.vue';
import { getImageLink } from '@/helpers/imageLink';
import { useViewStore } from '@/stores/view.store';

const eventStore = useEventStore();
const mainEvent = computed<EventEntity>(() => {
  const nextEvents = eventStore.getEventsTimeline.value?.nextEvents;

  const mainEvents = nextEvents?.filter((item: EventEntity) => {
    return item.isMainEvent;
  });

  if (mainEvents) {
    return mainEvents[mainEvents?.length - 1];
  } else if (nextEvents) {
    return nextEvents[nextEvents?.length - 1];
  }
  return undefined;
});

const viewStore = useViewStore();
const view = viewStore.getViewType;
</script>

<template>
  <section class="main-banner">
    <CourseBanner :squeeze="view && mainEvent != undefined" />
    <article class="main-event" v-if="mainEvent">
      <div class="event-image">
        <img :src="getImageLink(mainEvent.imageId)" alt="" />
      </div>
      <div class="event-content">
        <h3>{{ mainEvent.name }}</h3>
        <RouterLink :to="`/event/${mainEvent.id}`">
          <img src="/assets/icons/go-arrow.svg" alt="Перейти к событию" />
        </RouterLink>
      </div>
    </article>
  </section>
</template>

<style scoped lang="scss">
.main-event {
  width: 100%;
  flex: 1 440px;
  height: 600px;
  display: flex;
  overflow: hidden;
  position: relative;
  border-radius: 60px;
  flex-direction: column;
  background: var(--color-mono-50);

  .event-image {
    width: 100%;
    height: 400px;
    overflow: hidden;
    border-radius: 60px;

    display: flex;
    align-items: center;
    justify-content: center;

    img {
      min-width: 100%;
      min-height: 100%;
      object-fit: cover;
    }
  }

  .event-content {
    display: flex;
    height: 200px;
    align-items: flex-start;
    flex-direction: column;
    padding: 30px 40px 40px;
    justify-content: space-between;

    @media screen and (max-width: 1024px) {
      gap: 24px;
      height: auto;
    }

    h3 {
      line-height: 1.2;
      font-size: var(--font-size-l);
    }

    a {
      padding: 12px;
      border-radius: 12px;
      background: var(--color-mono-0);

      img {
        width: 24px;
        height: 24px;
        display: block;
      }
    }
  }
}

.main-banner {
  gap: 40px;
  display: flex;
  margin-top: 40px;

  @media screen and (min-height: 1000px) {
    margin-top: 100px;
  }

  @media screen and (max-width: 1200px) {
    margin-top: 40px;
    flex-direction: column;
  }
}
</style>
